/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import Calendar from './calendar/fr_FR';
import DatePicker from './date-picker/fr_FR';
import Pagination from './pagination/fr_FR';
import TimePicker from './time-picker/fr_FR';

export default {
  locale: 'fr',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Filtrer',
    filterConfirm: 'OK',
    filterReset: 'RÃ©initialiser',
    selectAll: 'Tout sÃ©lectionner',
    selectInvert: 'Inverser la sÃ©lection'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Annuler',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Annuler'
  },
  Transfer: {
    searchPlaceholder: 'Recherche',
    itemUnit: 'Ã©lÃ©ment',
    itemsUnit: 'Ã©lÃ©ments'
  },
  Upload: {
    uploading: 'TÃ©lÃ©versement en cours...',
    removeFile: 'Supprimer',
    uploadError: 'Erreur de tÃ©lÃ©versement',
    previewFile: 'Afficher l\'aperÃ§u du fichier'
  },
  Empty: {
    description: 'Aucune donnÃ©e'
  }
};
